const layoutStore = {
  namespaced: true,
  state: () => ({
    title: "",
    loading: true,
  }),
  mutations: {
    updateTitle(state, newTitle) {
      state.title = newTitle;
    },
    updateLoading(state, loading) {
      state.loading = loading;
    },
  },
  getters: {
    getTitle(state) {
      return state.title || "Americana de Turismo";
    },
  },
};

export default layoutStore;
